<template>
 <section
  class="n-section-primary tw-relative tw-overflow-hidden"
  :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
>
    <div v-if="variants.v1 === variant" class="tw-w-full tw-text-center">
      <h3 class="tw-mb-8">{{ vars.titleText }}</h3>
      <div class="tw-flex tw-flex-col tw-flex-wrap tw-items-center tw-justify-center tw-gap-10 lg:tw-flex-row">
        <div
          class="tw-flex tw-max-w-lg tw-flex-col tw-items-center tw-justify-start tw-rounded-lg tw-border-2 tw-p-4 tw-text-center"
          v-for="(card, index) in cards"
          :key="`valuation-card-${index}`"
        >
          <library-image :src="card.photo" style="border-radius: var(--rounded-sm)" />
          <div class="tw-mt-2 tw-flex tw-flex-col tw-items-center tw-justify-stretch tw-gap-3 tw-px-4 tw-py-2">
            <h4>{{ card.title }}</h4>
            <p class="tw-mb-4 tw-line-clamp-[6]">
              {{ card.description }}
            </p>
          </div>
          <nuxt-link
            class="tw-mb-4 tw-mt-auto"
            :class="`n-${card.button_type}`"
            :to="card.button_link"
            :external="true"
          >
            {{ card.button_label }}
          </nuxt-link>
        </div>
      </div>
    </div>
    <div v-if="variants.v2 === variant" class="tw-flex tw-w-full tw-justify-center tw-text-center">
      <div class="tw-relative tw-w-full tw-max-w-lg lg:tw-max-w-full">
        <h2 v-if="vars.titleText" class="tw-mb-6 md:tw-mb-10">{{ vars.titleText }}</h2>
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-mb-6 md:tw-mb-10"></div>
        <Swiper
          :modules="[SwiperPagination]"
          :slides-per-view="1"
          :space-between="10"
          effect="fade"
          :loop="true"
          :clickable="true"
          :watch-overflow="true"
          @slideChange="onSlideChange"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide
            v-for="(card, index) in cards"
            :key="`valuation-card-${index}`"
            class="!tw-flex tw-flex-col tw-items-center tw-justify-start tw-bg-white tw-p-4 tw-text-center"
            style="border: 1px solid var(--c-border); border-radius: var(--rounded)"
          >
            <library-image :src="card.photo" style="border-radius: var(--rounded-sm)" />
            <div class="tw-mt-2 tw-flex tw-flex-col tw-items-center tw-justify-stretch tw-gap-3 tw-px-4 tw-py-2">
              <h4 class="tw-line-clamp-1 tw-h-[40px]">{{ card.title }}</h4>
              <p class="tw-mb-4 tw-line-clamp-[6]">
                {{ card.description }}
              </p>
            </div>
            <nuxt-link
              :external="true"
              class="tw-mb-4 tw-mt-auto"
              :class="`n-${card.button_type}`"
              :to="card.button_link"
            >
              {{ card.button_label }}
            </nuxt-link>
          </SwiperSlide>
        </Swiper>
        <div class="xl:!tw-hidden">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v3"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
          />
        </div>
      </div>
    </div>

      <div v-if="variants.v3 === variant" class="tw-flex tw-w-full tw-justify-center tw-text-center tw-py-12 md:tw-py-0">
      <div class="tw-relative tw-w-full tw-max-w-lg lg:tw-max-w-full">
         <BlockSymbol
        v-if="vars.watermarkImage"
        :block-logo-image="String(vars.watermarkImage)"
        block-opacity="1"
        position-text="left_bottom"
        :company-key="company.company_key"
        image-class="wm-size wm-white"
      />
   <BlockSymbol
  v-if="vars.watermarkImage && isMobileDevice"
  :block-logo-image="String(vars.watermarkImage)"
  block-opacity="1"
  position-text="left_bottom"
  :company-key="company.company_key"
  image-class="m-size m-white"
/>
     
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-mb-6 md:tw-mb-10"></div>
        <Swiper
          :modules="[SwiperPagination]"
          :slides-per-view="1"
          :space-between="10"
          effect="fade"
          :loop="true"
          :clickable="true"
          :watch-overflow="true"
          @slideChange="onSlideChange"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide
            v-for="(card, index) in cards"
            :key="`valuation-card-${index}`"
            class="!tw-flex tw-flex-col tw-items-center tw-justify-start tw-bg-white tw-p-4 tw-text-center"
            style="border: 1px solid var(--c-border); border-radius: var(--rounded)"
          >
            <library-image :src="card.photo" style="border-radius: var(--rounded-sm)" />
            <div class="tw-mt-2 tw-flex tw-flex-col tw-items-center tw-justify-stretch tw-gap-3 tw-px-4 tw-py-2">
              <h3 class="tw-line-clamp-1 tw-h-[40px]">{{ card.title }}</h3>
              <p class="tw-mb-4 tw-line-clamp-[6]">
                {{ card.description }}
              </p>
            </div>
            <nuxt-link
              :external="true"
              class="tw-mb-4 tw-mt-auto"
              :class="`n-${card.button_type}`"
              :to="card.button_link"
            >
              {{ card.button_label }}
            </nuxt-link>
          </SwiperSlide>
        </Swiper>
        <div class="xl:!tw-hidden">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v13"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
          />
        </div>
      </div>
    </div>

      <div v-if="variants.v4 === variant" class="tw-flex tw-w-full tw-justify-center tw-text-center tw-py-12 md:tw-py-0">
      <div class="tw-relative tw-w-full tw-max-w-lg lg:tw-max-w-full">
         <BlockSymbol
        v-if="vars.watermarkImage"
        :block-logo-image="String(vars.watermarkImage)"
        block-opacity="1"
        position-text="left_bottom"
        :company-key="company.company_key"
        image-class="wm-size wm-white"
      />
   <BlockSymbol
  v-if="vars.watermarkImage && isMobileDevice"
  :block-logo-image="String(vars.watermarkImage)"
  block-opacity="1"
  position-text="left_bottom"
  :company-key="company.company_key"
  image-class="m-size m-white"
/>
     
        <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-mb-6 md:tw-mb-10"></div>
        <Swiper
          :modules="[SwiperPagination]"
          :slides-per-view="1"
          :space-between="10"
          effect="fade"
          :loop="true"
          :clickable="true"
          :watch-overflow="true"
       
          @slideChange="onSlideChange"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide
            v-for="(card, index) in cards"
            :key="`valuation-card-${index}`"
            class="!tw-flex tw-flex-col tw-items-center tw-justify-start tw-bg-white hover:!tw-text-white  hover:tw-bg-[#424242] tw-p-4 tw-text-center"
            style="border: 1px solid var(--c-border); border-radius: var(--rounded)"
          >
            <library-image :src="card.photo" style="border-radius: var(--rounded-sm)" />
            <div class="tw-mt-2 tw-flex tw-flex-col tw-items-center tw-justify-stretch tw-gap-3 tw-px-4 tw-py-2">
              <h3 class="tw-line-clamp-1 tw-h-[40px]">{{ card.title }}</h3>
              <p class="tw-mb-4  tw-line-clamp-[6]">
                {{ card.description }}
              </p>
            </div>
            <nuxt-link
              :external="true"
              class="tw-mb-4 tw-mt-auto"
              :class="`n-${card.button_type}`"
              :to="card.button_link"
            >
              {{ card.button_label }}
            </nuxt-link>
          </SwiperSlide>
        </Swiper>
        <div class="xl:!tw-hidden">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v13"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'OurValuations',

  mixins: [ComponentMixin],
    components: { BlockSymbol },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>

<style scoped>
.swiper-slide {
  height: auto;
}

:deep(.wm-size) {
  display: block;              
  transform: translate(1100px, 90px); 
}

:deep(.m-size) {
  width: 100vw;        
  max-width: 680px;  
  height: auto;      
  top: 558px;       
  left: 160px;         
  opacity: 1;       
  display: block;
}

/* Masaüstünde tamamen gizle */
@media (min-width: 1024px) {
  :deep(.m-size) {
    display: none !important;
  }
}

</style>
